export const DROPDOWN_PORTAL_ID = 'talos-dropdown-portal-id';
export const DROPDOWN_ID_2 = 'talos-dropdown-portal-id-2';
